const FAQ_ITEMS = [
  {
    q: '麻花影视需要注册会员才能观看吗？',
    a: '不需要。麻花影视所有内容完全免费，无需注册、无需登录、无需付费，打开网站即可直接观看高清影视内容。我们聚合飘花电影网、555电影、8090电影网等主流平台资源，致力于让每一位用户零门槛享受观影乐趣。',
  },
  {
    q: '为什么有些视频加载速度比较慢？',
    a: '视频加载速度与您的网络环境、当前时段访问量以及CDN节点分配有关。麻花影视采用全网智能CDN加速技术，会自动为您选择最优节点。如遇卡顿，建议尝试切换清晰度或稍等片刻，通常高峰期外播放会更加流畅。',
  },
  {
    q: '如何快速找到我想看的电影或电视剧？',
    a: '您可以通过首页的专题索引按类型浏览，也可以使用搜索功能输入影片名称、演员或导演关键词快速定位。此外，热度榜单和最新动态模块也会帮您发现当下最受欢迎的影视内容。',
  },
  {
    q: '麻花影视支持哪些设备观看？',
    a: '支持电脑、平板、手机等多终端观看，适配主流浏览器（Chrome、Safari、Edge等）。我们还提供移动端应用，iOS和安卓版本均可下载，观影记录和收藏片单可跨设备同步，走到哪看到哪。',
  },
  {
    q: '影片更新频率是怎样的？',
    a: '麻花影视与各大平台保持同步更新节奏。最新上映电影通常在上线后24小时内收录，热播电视剧和综艺节目在播出当天同步更新。我们的内容团队全天候监控片源动态，确保您不会错过任何精彩内容。',
  },
  {
    q: '遇到无法播放或画面异常怎么办？',
    a: '首先建议您刷新页面或切换浏览器尝试。如果问题依然存在，可以尝试切换视频清晰度（标清/高清自适应选择），或通过联系我们页面反馈具体影片名称和问题描述，技术团队会尽快排查处理。',
  },
];

export default function SectionFaq() {
  return (
    <section id="faq" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于麻花影视，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl bg-background-200/60 border border-background-300/40 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 pr-4">
                  {item.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-background-300/50 group-open:bg-primary-500/20 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:text-primary-400 text-sm transition-transform group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-400 leading-relaxed border-t border-background-300/30 pt-4">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}